import {ChangeDetectionStrategy, Component, OnInit, ViewChild} from '@angular/core';
import {AbstractControl, FormControl, FormGroup, Validators} from '@angular/forms';
import {NgxModal} from '@ngx-component-kit/cards/modal/modal.component';
import {AuthService} from '@core/services/auth.service';
import {BehaviorSubject} from 'rxjs';

@Component({
    selector: 'app-admin-dashboard-change-password',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChangePasswordComponent implements OnInit {

    // Modal.
    @ViewChild('modal', { static: true }) modal: NgxModal;

    // Form.
    form: FormGroup;

    // State.
    isLoading$ = new BehaviorSubject(false);
    state$ = new BehaviorSubject<string>(null);

    constructor(private _auth: AuthService) {
    }

    get currentPassword() {
        return this.form.get('current_password');
    }

    get newPassword() {
        return this.form.get('password');
    }

    ngOnInit() {
        // Get the validators.
        const required = Validators.required;
        const minLength = Validators.minLength(6);

        // Create the form.
        this.form = new FormGroup({
            current_password: new FormControl('', required),
            password: new FormControl('', [required, minLength]),
            confirm_password: new FormControl('', required)
        }, {validators: PasswordValidation.matchPassword});
    }

    async onSubmit() {
        // Set a loading state to true.
        this.isLoading$.next(true);

        try {
            // Change the password.
            await this._auth.changePassword({
                current_password: this.currentPassword.value,
                password: this.newPassword.value
            });

            // Set the success state.
            this.state$.next('success');
        } catch (error) {
            // Set the error state.
            this.state$.next('error');

            // Reset the password because it must have been wrong.
            this.currentPassword.reset();

            // Stop the loading.
            this.isLoading$.next(false);
        }
    }

}

class PasswordValidation {

    static matchPassword(control: AbstractControl) {
        // Get the controls.
        const newControl = control.get('password');
        const confirmControl = control.get('confirm_password');

        // Set the errors.
        confirmControl.setErrors(newControl.value !== confirmControl.value ? {matchPassword: true} : null);

        // Return a value.
        return null;
    }

}
